/* MODULE IMPORTS */
import React, { Component } from "react";

import "./MyMontepioAppPopup.css";
import mymontepioadventoImg from "../../images/mymontepioadvento.png"

class MyMontepioapp extends Component {
    static displayName = MyMontepioapp.name;

    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <div className="popup-campanha">
                <div className="popup-content">

                    <button
                        className="popup-close"
                        onClick={() => {
                            this.props.close();
                        }}
                    >
                        X
                    </button>


                    <div className="popup-campanha-text">
                        <img
                            src={mymontepioadventoImg}
                            alt="mymontepio popup"
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default MyMontepioapp;
